import { useResetAtom } from 'jotai/utils';
import { useCallback } from 'react';
import {
  isViewingOnlyActiveOrchestrationsAtom,
  selectedRunOrchestrationViewAtom,
} from './atoms';

/**
 * Resets the persisted "View only Active" switch and List/Split/Column view
 * selection on the Run Orchestrations banner back to their defaults, clearing
 * their localStorage entries in the process - mirroring
 * `useResetDashboardFilters` for the dashboard's persisted filter/column atoms.
 *
 * Intended to be called on user logout, so a fresh session (whether the
 * same user logging back in or a different user on the same machine)
 * starts with the switch off and List view instead of inheriting a stale choice.
 */
export const useResetRunOrchestrationBanner = () => {
  const resetIsViewingOnlyActive = useResetAtom(
    isViewingOnlyActiveOrchestrationsAtom
  );
  const resetSelectedView = useResetAtom(selectedRunOrchestrationViewAtom);

  return useCallback(() => {
    resetIsViewingOnlyActive();
    resetSelectedView();
  }, [resetIsViewingOnlyActive, resetSelectedView]);
};

